import { useState } from "react";
import { Link } from "react-router-dom";
import { type MeUser, useAdminUsers, useUpdateUserRole } from "../lib/api";

function RoleAction({
  user,
  onChange,
}: { user: MeUser; onChange: (uid: string, role: "user" | "sub_admin") => void }) {
  if (user.role === "admin") return <span className="text-slate-600">—</span>;
  if (user.role === "sub_admin") {
    return (
      <button
        type="button"
        onClick={() => onChange(user.uid, "user")}
        className="text-slate-400 transition hover:text-fuchsia-400"
      >
        해제
      </button>
    );
  }
  return (
    <button
      type="button"
      onClick={() => onChange(user.uid, "sub_admin")}
      className="text-cyan-300 transition hover:text-cyan-200"
    >
      부관리자 임명
    </button>
  );
}

export function AdminUsers() {
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const { data, isLoading } = useAdminUsers(q, page);
  const roleMutation = useUpdateUserRole();

  const onChange = (uid: string, role: "user" | "sub_admin") => roleMutation.mutate({ uid, role });

  return (
    <section className="mx-auto max-w-3xl fade-up">
      <div className="glass neon-border rounded-2xl p-7">
        <h1 className="neon-text text-2xl font-bold">유저 관리</h1>

        <input
          value={q}
          onChange={(e) => {
            setQ(e.target.value);
            setPage(1);
          }}
          placeholder="이메일/닉네임 검색"
          className="input-cyber mt-4 w-full rounded-lg px-3 py-2"
        />

        {isLoading ? (
          <p className="mt-6 text-center font-mono text-sm text-cyan-300/70">불러오는 중…</p>
        ) : (
          <table className="mt-4 w-full text-sm">
            <thead>
              <tr className="text-left text-slate-500">
                <th className="py-2">닉네임</th>
                <th className="py-2">이메일</th>
                <th className="py-2">역할</th>
                <th className="py-2 text-right">액션</th>
              </tr>
            </thead>
            <tbody>
              {data?.users.map((u) => (
                <tr key={u.uid} className="border-t border-slate-800">
                  <td className="py-2">
                    <Link to={`/users/${u.uid}`} className="text-cyan-300 hover:underline">
                      {u.nickname}
                    </Link>
                  </td>
                  <td className="py-2 text-slate-400">{u.email}</td>
                  <td className="py-2 font-mono text-xs text-slate-300">{u.role}</td>
                  <td className="py-2 text-right">
                    <RoleAction user={u} onChange={onChange} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {data && data.total > data.pageSize && (
          <div className="mt-4 flex justify-center gap-3 text-sm">
            <button
              type="button"
              disabled={page <= 1}
              onClick={() => setPage((p) => p - 1)}
              className="btn-neon rounded-lg px-3 py-1 disabled:opacity-40"
            >
              이전
            </button>
            <span className="py-1 text-slate-400">{page}</span>
            <button
              type="button"
              disabled={page * data.pageSize >= data.total}
              onClick={() => setPage((p) => p + 1)}
              className="btn-neon rounded-lg px-3 py-1 disabled:opacity-40"
            >
              다음
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
